const Theme = {
  body_background_color: '#6CB6D0',
  title_font: 'Korolev Heavy',
  text_font: 'Barlow Condensed',
  logo_image_url: 'journeeinnovation.png',
  token_url: 'journeeinnovation.png',
  number_hidden: true,
  header_full_height: true,
  header_no_margin: true,
  header_no_border: true,
  logo_full_width: true,
  button_border_width: 2,
  button_color: '#6CB6D0',
  button_hover_text_color: '#6CB6D0',
  button_radius: 20,
  button_outlined_border_color: '#6CB6D0',
  button_outlined_hover_border_color: '#6CB6D0'
}

export default Theme